import classes from './Select.module.css';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

type CustomSelectProps = {
  options: Array<{ label: string; value: any }>;
  onChange: (value: any) => void;
  isError?: boolean;
  required?: boolean;
  placeholder?: string;
  id?: string;
  name?: string;
  value: string;
  disabled?: boolean;
} & HTMLAttributes<HTMLSelectElement>;

export const Select = ({
  options,
  onChange,
  isError = false,
  required = false,
  placeholder,
  name,
  id,
  value = '',
  disabled = false,
}: CustomSelectProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  const combinedSelect = cn(classes.container, { [classes.isError]: isError });

  return (
    <select
      required={required}
      className={combinedSelect}
      onChange={handleChange}
      value={value ?? ''}
      aria-invalid={isError}
      name={name}
      id={id}
      disabled={disabled}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
